<template>
  <div class="pb-16 pt-6 lg:py-24">
    <div class="mx-auto w-full max-w-screen-xl container">
      <VcTypography :tag="heading" class="text-2xl">{{ title }}</VcTypography>

      <p>{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

export interface IProps {
  heading: string;
  title: string;
  subtitle?: string;
  background?: string;
}

const props = defineProps<IProps>();

const ALLOWED_HEADINGS = ["h1", "h2", "h3", "h4", "h5", "h6"];

const safeHeading = computed(() => {
  const clean = props.heading?.replace(/[^\w-]/g, "") ?? "h2";
  return ALLOWED_HEADINGS.includes(clean) ? clean : "h2";
});
</script>

<style lang="scss">
.title-block {
  &.bg-neutral-800 {
    color: white;
  }
}
</style>
